import {
  LOG_IN_REQUEST,
  LOG_IN_SUCCESS,
  LOG_IN_FAILURE,
  LOG_OUT_REQUEST,
  LOG_OUT_SUCCESS,
  LOG_OUT_FAILURE,
  SET_SHOW_DEMO_DATA,
  RESET_LATEST_EXPIRED_PLAN,
  DISABLE_SIGNIN,
  ENABLE_SIGNIN,
} from "../../constants/ActionTypes";
import { replace } from "react-router-redux";
import { UsersApi } from "../api/UsersApi";
import { getUserRequest, getUserSuccess, getUserFailure } from "./AccountSetting";
import moment from "moment";
import { isEnabledDisplayExecutiveList, isEnabledSendLetter } from '../../utils/planUtils';

const resetLatestExpiredPlan = () => ({
  type: RESET_LATEST_EXPIRED_PLAN,
});

const loginRequest = () => ({
  type: LOG_IN_REQUEST,
});

export const loginSuccess = (user) => ({
  type: LOG_IN_SUCCESS,
  payload: {
    user: user,
  },
});

const loginFailure = (error) => ({
  type: LOG_IN_FAILURE,
  payload: {
    error: error,
  },
});

const logoutRequest = () => ({
  type: LOG_OUT_REQUEST,
});

const logoutSuccess = () => ({
  type: LOG_OUT_SUCCESS,
});

const logoutFailure = (error) => ({
  type: LOG_OUT_FAILURE,
  payload: {
    error: error,
  },
});

export const setShowDemoData = (user) => ({
  type: SET_SHOW_DEMO_DATA,
  payload: {
    user: user,
  },
});

export const loginRedirect = (user, dispatch) => {
  if (user && user.active_plan && user.active_plan.id === 1) {
    // 無料アカウントの場合パスワード変更は促さない
    return false;
  } else if (!user.user_role && user.latest_password_reset_log === null) {
    //パスワード変更履歴がない場合、初回ログインと看做され
    //子アカウントではない場合はセキュリティ質問の設定、パスワードの変更を促す
    dispatch(replace(`/setting/reset-password?first_time=true`));
    return true;
  } else if (
    (!user.user_role && !user.security_question) &&
    user.latest_password_reset_log !== null &&
    moment().diff(
      moment(user.latest_password_reset_log.instruct_at),
      "years"
    ) >= 1
  ) {
    // 子アカウントではない・セキュリティの質問が設定されてない・前回パスワード変更に1年経ったユーザ
    dispatch(replace(`/setting/reset-password?first_time=true`));
    return true;
  } else if (!user.user_role && !user.security_question) {
    // 子アカウントではない・セキュリティの質問が設定されてないユーザは、
    // セキュリティの質問が設定画面に遷移
    dispatch(replace(`/setting/update-security-question`));
    return true;
  } else if (
    !user.user_role &&
    user.latest_password_reset_log !== null &&
    moment().diff(
      moment(user.latest_password_reset_log.instruct_at),
      "years"
    ) >= 1
  ) {
    // 子アカウントではない・前回パスワード変更に1年経ったらログイン時に
    // パスワードを変更を促す
    dispatch(replace(`/setting/reset-password`));
    return true;
  } else {
    return false;
  }
};

const disableSignin = () => ({
  type: DISABLE_SIGNIN,
});

const enableSignin = () => ({
  type: ENABLE_SIGNIN,
});

export const signin = (loginInfo) => {
  return (dispatch, getState) => {
    dispatch(disableSignin());
    dispatch(resetLatestExpiredPlan());
    dispatch(loginRequest());
    dispatch(getUserRequest());

    UsersApi.login(loginInfo, dispatch)
      .then((response) => {
        localStorage.setItem("user", JSON.stringify({ email: loginInfo.email, loginTime: new Date() }));
        dispatch(loginSuccess(response));

        // TODO バックエンドのUserResourceクラスが重いので改善した方がよい。
        UsersApi.getUser(dispatch)
          .then((response) => {
            const user = response.data.data;
            dispatch(getUserSuccess(user));

            if ((user.active_plan !== null) && !loginRedirect(user, dispatch)) {
              const routerState = getState().router.location.state;
              const from = (routerState && routerState.from)
                ? (routerState.from.search
                    ? `${routerState.from.pathname}${routerState.from.search}`
                    : routerState.from.pathname)
                : null;

              // TODO バックエンドからのダミーデータを取得ではなく、フロントのみでダミーデータ表示する処理ができそう。フロントのみで処理ができれば、UserResourceクラスのレスポンスが重い問題を改善できる
              dispatch(setShowDemoData(user));

              if (!isEnabledSendLetter(user)) {
                // レターを使わないプラン（KDB閲覧プラン・無料プラン）は、ログイン後の
                // 最初の遷移先をダッシュボードではなくキーマンデータベース（エグゼクティブリスト）にする
                dispatch(replace(`/executive-list`));
              } else if (!isEnabledDisplayExecutiveList(user)) {
                // キーマンデータベースが表示できない場合はダッシュボード
                dispatch(replace(from ? from : `/order-dashboard`));
              } else {
                // それ以外は常にキーマンデータベースを表示
                dispatch(replace(from ? from : `/executive-list`));
              }
            } else {
              // ログイン成功しないときのみenableにする。成功した場合は非同期処理のページ遷移前にenableにならないようにするため。
              // また、ログアウトや再度signinページに遷移するときenableとなるので、この仕様で問題ない。
              dispatch(enableSignin());
            }
          })
          .catch((error) => {
            dispatch(getUserFailure(error.response));
            // ログイン成功しないときのみenableにする。成功した場合は非同期処理のページ遷移前にenableにならないようにするため。
            // また、ログアウトや再度signinページに遷移するときenableとなるので、この仕様で問題ない。
            dispatch(enableSignin());
          });
      })
      .catch((error) => {
        dispatch(loginFailure(error.response.data));
        dispatch(enableSignin());
      });
  };
};

export const signout = () => {
  return (dispatch) => {
    dispatch(logoutRequest());
    dispatch(enableSignin());

    UsersApi.logout(dispatch)
      .then(() => {
        localStorage.removeItem("user");
        dispatch(logoutSuccess());
      })
      .catch((error) => {
        dispatch(logoutFailure(error.response.data));
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/Signin.js